import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { UpdatePaymentMethod } from '../../store/actions/payment-method.actions';
import { Router} from '@angular/router';
import { CustomerStorageService } from '../../services/customer-storage.service';
import { RibInterface } from '../../models/rib.interface';
import { CustomerInterface } from '../../models/customer.interface';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { CheckPasswordInterfaceState } from '../../../shared/store/state/check-password.state';
import { CheckPasswordInterface } from '../../../shared/models/check-password.interface';
import { environment } from '../../../../../environments/environment';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { ExtranetService } from '../../../shared/services/extranet.service';

@Component({
    selector: 'app-update-payment-method',
    templateUrl: './update-payment-method.component.html',
    styleUrls: ['./update-payment-method.component.css'],
    standalone: false
})
export class UpdatePaymentMethodComponent implements OnInit {

    environment = environment;
    constHelper = ConstsHelper;
    customer: CustomerInterface;
    paymentForm: FormGroup;
    paymentFormSubmitted: boolean;
    acceptSepa: boolean;
    procedurePayload: any;
    passwordResponse: CheckPasswordInterface;
    errors: any = {
        iban: {
            required: `L'IBAN est requis.`,
            pattern: `L'IBAN saisie n'est pas valide.`
        },
        bic: {
            required: `Le BIC est requis.`,
            pattern: `Le BIC saisie n'est pas valide.`
        }
    };
    supportUser: SupportUserInterface;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private store: Store<any>,
        private customerStorage: CustomerStorageService,
        private extranetService: ExtranetService
    ) {}

    ngOnInit() {
        this.acceptSepa = false;
        this.store.pipe(select(ConstsHelper.REDUCER_CHECK_PASSWORD)).subscribe((response: CheckPasswordInterfaceState) => {
            if (response.result && response.result.page === 'payment') {
                this.passwordResponse = response.result;
            }
        });

        this.supportUser = this.extranetService.getSupportUser();
        if (this.supportUser == null && (!this.passwordResponse || this.passwordResponse.isValid === false)) {
            this.router.navigate(['compte/paiement']);
        }
        this.paymentFormSubmitted = false;
        this.customer = this.customerStorage.getCustomer();
        this.procedurePayload = { routeValue: 'debit_pay_method_change' };
        this.initIbanForm();
    }

    /**
     * Init payment method form
     */
    initIbanForm() {
        this.paymentForm = this.formBuilder.group({});
        this.paymentForm.addControl('iban', this.formBuilder.control('', [Validators.required]));
        this.paymentForm.addControl('bic', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.bicPattern)]));
      }

    /**
     * Save payment method
     */
    savePaymentMethod() {
        this.paymentFormSubmitted = true;
        if (this.paymentForm.valid && this.acceptSepa) {
            const rib = {
                iban: this.paymentForm.get('iban').value,
                bic: this.paymentForm.get('bic').value,
                password: !this.supportUser ? this.passwordResponse.password : null
            } as RibInterface;
            this.store.dispatch(new UpdatePaymentMethod(rib));
            this.paymentFormSubmitted = false;
            this.router.navigate(['/compte/paiement']);
        }
    }

    cancel() {
        this.router.navigate(['/compte/paiement']);
    }

    setSepa($event) {
        this.acceptSepa = $event.target.checked;
    }

    getError(formControlName: string): string {
        let errorMsg = '';
        if (this.paymentForm.controls[formControlName].invalid) {
            Object.keys(this.paymentForm.controls[formControlName].errors).map(
                key => {
                    errorMsg = this.errors[formControlName][key];
                }
            );
        }
        return errorMsg;
    }
}
